import React from "react";

export function BillingCard({ children }: { children: React.ReactNode }) {
  return (
    <section className="border-base-border flex flex-col gap-5 rounded-xl border bg-white p-6 shadow-sm">
      {children}
    </section>
  );
}
